const ctmFormSchema = require('./choo/quote_form_schema.json');

const choosiFormSchema = JSON.parse(JSON.stringify(ctmFormSchema));

/*
 * Change the style of all nextStepButton's on all pages. "nextStepButton" is
 * not targetable using the component override system. This is less maintenance
 * than a copy and paste of the schema wholesale.
 */
for (let i = 0; i < choosiFormSchema.pages.length; i += 1) {
    const page = choosiFormSchema.pages[i];
    if (page.nextStepButton) {
        page.nextStepButton.icon = null;
        page.nextStepButton.variant = 'choosi_car';
    }
}

export default {
    choo: {
        components: require('./choo/components.json'),
        pageSchema: require('./choo/page_schema.json'),
        layoutComponentMappingSchema: require('./choo/layout_component_mapping.json'),
        quoteFormSchema: choosiFormSchema
    },
    islt: {
        components: require('../component/components.json'),
        pageSchema: require('../page_schema.json'),
        layoutComponentMappingSchema: require('../layout_component_mapping.json'),
        quoteFormSchema: require('../form/quote_form_schema.json')
    }
};

